<template>
  <div
    id="emailInput"
    class="flex flex-col lg:flex-row bg-efblue-9 shadow-darkflat text-white rounded p-6 md:p-10 w-full"
  >
    <div
      v-if="!emailSent"
      class="mb-8 lg:mb-0 lg:mr-4 text-sm leading-relaxed w-full lg:w-1/2"
    >
      <p class="mb-4">
        Please state the e-mail address you want us to use in our communication
        with you.
      </p>
      <p>
        We will send an e-mail to you with a link. Please click on that link to
        access the claim form.
      </p>
    </div>

    <div
      v-if="!emailSent"
      class="flex flex-col justify-center lg:ml-4 w-full lg:w-1/2"
    >
      <EmailInput
        :error="error"
        :email="email"
        :invalid="$v.email.$invalid"
        :disabled="$v.$invalid || email === ''"
        :show-loader="showLoader"
        @input="email = $event"
        @click="sendEmail"
      />

      <BaseContextualErrorMessage :message="error" color="light" />
    </div>

    <ConfirmationMessage v-if="emailSent" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { email } from 'vuelidate/lib/validators';

import EmailInput from '@/components/Start/EmailForm/EmailInput.vue';
import ConfirmationMessage from '@/components/Start/EmailForm/ConfirmationMessage.vue';

import http from '@/store/shared/http';
export default {
  name: 'EmailForm',
  components: {
    EmailInput,
    ConfirmationMessage
  },
  props: {
    emailSent: Boolean
  },
  data: () => ({
    email: '',
    showLoader: false,
    error: ''
  }),
  computed: {
    ...mapState({
      customer: (state) => state.customer.customer
    })
  },
  validations: {
    email: { email }
  },
  methods: {
    sendEmail() {
      this.showLoader = true;
      this.error = '';

      http
        .post('/emails', {
          birthDate: this.customer.birthDate,
          efSalesRefCode: this.customer.efSalesRefCode,
          email: this.email,
          firstName: this.customer.firstName
        })
        .then(() => {
          this.showLoader = false;
          this.$emit('completed');
          this.scrollToTop();
        })
        .catch(() => {
          this.error = `An error occurred when trying to send confirmation e-mail to '${this.email}'`;
        })
        .finally(() => (this.showLoader = false));
    }
  }
};
</script>
